export default __webpack_public_path__ + "static/media/aliopecia-areatap.f701faff.pdf";